
import KakaoHelper from '../../utils/KakaoHelper';
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
     youtube: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      localIsVisible: this.isVisible,
      id: this.userId,
      youtubeImg: this.youtube,
      url: null,
      kakaoHelper:null,
    };
  },
  methods: {

    copyUrlToClipboard() {
      navigator.clipboard.writeText(this.url).then(() => {
        alert('URL이 복사되었습니다.');
      }).catch(err => {
        console.error('클립보드에 복사하는 데 실패했습니다.', err);
      });
    },

    closePopup() {
      this.localIsVisible = false;
      this.$emit('close', false);
    },

    kakaoShare() {
        this.kakaoHelper.initShareLive(this.youtubeImg);
    }

  },
  mounted() {
    if (process.client) {
      this.url = window.location.href;
    }
    this.kakaoHelper = new KakaoHelper(Kakao);

  },

};
